import { render, staticRenderFns } from "./Plattelands.vue?vue&type=template&id=f04ed42c&scoped=true"
import script from "./Plattelands.vue?vue&type=script&lang=js"
export * from "./Plattelands.vue?vue&type=script&lang=js"
import style0 from "./Plattelands.vue?vue&type=style&index=0&id=f04ed42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04ed42c",
  null
  
)

export default component.exports